import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://electrowave.kr';
const DEFAULT_OG_IMAGE = '/assets/electrowave-logo.svg';
const SITE_NAME = 'ElectroWave Club';

const buildAbsoluteUrl = (path = '/') => {
  if (!path) return SITE_URL;
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const Seo = ({
  title,
  description,
  path = '/',
  ogImage,
  ogType = 'website',
  jsonLd,
  noindex = false,
}) => {
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} - ${SITE_NAME}`;
  const url = buildAbsoluteUrl(path);
  const imageUrl = buildAbsoluteUrl(ogImage || DEFAULT_OG_IMAGE);

  const ldArray = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ko_KR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {ldArray.map((ld, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
